<template>
    <section class="kiwi-bg-primary fill-height position-relative">
        <img src="/assets/blobs_auth-screen.svg" class="position-absolute z-1" alt="" style="left: 50%; top: 0; transform: translateX(-50%);">
        <img src="/assets/Mask group_auth-screen.svg" class="position-absolute z-1" alt="" style="bottom: 0; right: 0;">
        <v-container fluid class="fill-height px-sm-8 px-md-16 kiwi-bg-primary authenticate-container position-relative">
            <v-responsive
            class="align-centerfill-height mx-auto"
            >
            <!-- max-width="1300" -->
            <v-sheet class="align-centerfill-height kiwi-bg-primary w-100">
                <v-row class="align-center">
                    <v-col cols="12" md="6" lg="6" xl="6" order-md="1">
                        <Register v-if="$route.path === '/register' && institute.$hasFeature('email-signup')" style="box-shadow: 0px 24px 48px -12px rgba(16, 24, 40, 0.08);" />
                        <Login v-else-if="$route.path === '/login'" style="box-shadow: 0px 24px 48px -12px rgba(16, 24, 40, 0.08);" />
                    </v-col>
                    <!-- <v-col cols="12" md="1" lg="1" order-md="2"></v-col> -->
                    <v-col cols="12" md="5" lg="6" xl="6" order-md="3">
                        <Slider />
                    </v-col>
                    <!-- <v-col cols="12" md="1" lg="2" xl="3"></v-col> -->
                </v-row>
            </v-sheet>
            </v-responsive>
        </v-container>
    </section>
</template>

<script setup>
  import Register from '../components/Auth/Register.vue'
  import Login from '../components/Auth/Login.vue'
  import Slider from '../components/Auth/Slider.vue'
  import { useInstituteStore } from '@/stores/institute/institute-store';
  import Intercom from '@intercom/messenger-js-sdk';
import { storeToRefs } from 'pinia';
import { onMounted, computed } from 'vue';
const institute = useInstituteStore()
const {configData} = storeToRefs(institute)


const enabled_features = computed(() => {
    return configData.value?.institute?.enabled_features
})
onMounted(() => {
    setTimeout(() => {
        if(enabled_features.value?.includes('intercom-chat')) {
            Intercom({
              app_id: 'wgokdvuc',
            });
        }
    }, 500)
})
</script>
